import Dollar from "@/src/search/PriceComparison/Dollar";
import * as stylex from "@stylexjs/stylex";

import { ComposableSpacing, type PropsWithStyleX, colors } from "../../../styles/tokens.stylex";

type IPriceComparisonItemCB = PropsWithStyleX & {
    iconStyleX?: stylex.StyleXStyles;
    labelText: string;
    color?: string;
};

export default function PriceComparisonItemCashbackLabel(props: IPriceComparisonItemCB) {
    return (
        <div {...stylex.props(styles.labelComponent, props.styleX)}>
            <Dollar styleX={[styles.icon, props.iconStyleX]} color={props.color || colors.b_BrandMagenta} />
            <span>{props.labelText}</span>
        </div>
    );
}

const styles = stylex.create({
    labelComponent: {
        gap: ComposableSpacing.s1,
        alignItems: "center",
        color: colors.b_BrandMagenta,
        display: "inline-flex",
        fontSize: "1rem",
    },

    icon: {
        height: "1em",
        width: "1em",
    },
});
